import { Box, Button } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { primitive, spacing } from 'styles/constants';
import { isWeb } from 'utils/environment';

export const Title = withTypography({ bold: true, textAlign: 'center', fontSize: 'xs' });

export const TitlePointDivider = withTypography({
  fontSize: 'xl',
  style: { paddingTop: isWeb ? undefined : spacing.$1 },
});

export const DescriptionPart = withTypography({
  style: { paddingTop: isWeb ? undefined : spacing.$0_5 },
});

export const Container = Box.withConfig<{ hasTitle?: boolean }>(p => ({
  flexDir: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'center',
  padding: spacing.$0_5,
  paddingBottom: p.hasTitle ? '0' : spacing.$1_5,
}));

export const ModalBodyContainer = Box.withConfig({
  maxWidth: 320,
});

export const ModalItemContainer = Box.withConfig({
  marginTop: '$4',
});

export const ModalSubtitleContainer = Box.withConfig({
  _text: {
    fontWeight: 'bold',
  },

  flexDirection: 'row',
});

export const IconContainer = Button.withConfig({
  variant: 'ghost',
  padding: '$1',
});

export const DesktopContainer = Box.withConfig({
  borderBottomWidth: 1,
  borderBottomColor: primitive.$blackOpacity10,
});
